import type { PlanInformation, TimeLinkage } from '@linktivity/ars-neo';
import { TimeLinkageType } from '@linktivity/ars-neo';

/**
 * Resolve the PlanInformation entry for a given plan id. When no planId is
 * provided, falls back to the first entry (e.g. calendar default view).
 * Returns undefined when planId is specified but not present in the list.
 */
export const findPlanInfo = (
  planInfos?: Array<PlanInformation>,
  planId?: string
): PlanInformation | undefined => {
  if (!planInfos || planInfos.length === 0) return undefined;
  if (!planId) return planInfos[0];
  return planInfos.find(p => p.planId === planId);
};

/**
 * True when the option's date must follow the main product's date
 * (SAME_DAY / SAME_DAY_AFTER_PARENT / SAME_DAY_BEFORE_PARENT linkage).
 */
export const isSameDayLinkage = (timeLinkage?: TimeLinkage): boolean =>
  timeLinkage?.type === TimeLinkageType.SameDay ||
  timeLinkage?.type === TimeLinkageType.SameDayAfterParent ||
  timeLinkage?.type === TimeLinkageType.SameDayBeforeParent;
